import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (sessionId) {
        try { await api.post("/auth/session", { session_id: sessionId }); } catch (e) { console.error("Auth session exchange failed", e); }
      }
      window.location.href = "/"; // full reload; AuthProvider re-fetches /auth/me
    })();
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center text-primary">
      <Loader2 className="w-8 h-8 animate-spin" />
    </div>
  );
}
